export default {
    getList: {
        getProcessWorkList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/active',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userProcessWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}